import React from 'react';
import {Box, styled} from '@mui/material';
import {Icon, designSystemToken} from '@lightricks/react-design-system';
import translate from '@/utils/translate';

interface MetricCardAverageComparisonProps {
  value: number;
  average: number;
}

const Container = styled(Box)`
  text-align: left;
  justify-content: center;
  display: flex;
  flex-direction: column;
  color: ${designSystemToken('semantic.fg.primary')};
  font-size: 12px;
  font-family: 'Brown LL';
  font-weight: 500;
  line-height: 16px;
  word-wrap: break-word;
  padding-bottom: 4px;
`;

const DifferenceContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: 4px;
`;

function formatDifference(difference: string, isAboveAverage: boolean): string {
  const comparisonText = isAboveAverage
    ? translate('above')
    : translate('below');
  return `${difference}× ${comparisonText} ${translate('avg')}`;
}

function MetricCardAverageComparison(props: MetricCardAverageComparisonProps) {
  const {value, average} = props;

  const difference: string = ((value - average) * 100).toFixed(2);
  const isAboveAverage = value > average;

  return (
    <Container>
      <DifferenceContainer>
        <Icon
          name="Colored-Subscribe"
          size="small"
          color="var(--pink-A200, #FF4081)"
          appearance="black"
        />
        {formatDifference(difference, isAboveAverage)}
      </DifferenceContainer>
    </Container>
  );
}

export default MetricCardAverageComparison;
